<template>
  <div class="mt-component-form print-container mb-4">
    <vs-row class="my-4 center-flex">
      <h5><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto">
        <vs-button v-if="!isPrint" color="secondary" @click="handleAddRow">구성물질 추가</vs-button>
        <vs-button v-if="!isPrint" class="ml-4" color="secondary" type="border" @click="handleRemoveRow">선택삭제</vs-button>
      </div>
    </vs-row>

    <div class="w-full" style="overflow-x: auto">
      <table>
        <colgroup>
          <col v-if="!isPrint" width="66" />
          <col width="370" />
          <col width="370" />
          <col width="170" />
          <col width="100" />
          <col width="120" />
          <col width="120" />
          <col width="120" />
          <col width="120" />

          <col width="120" />
          <col width="120" />
          <col width="120" />
          <col width="120" />
        </colgroup>
        <thead>
        <tr>
          <th v-if="!isPrint" rowspan="2">
            <vs-checkbox v-model="tableAllCheck" class="custom-checkbox"></vs-checkbox>
          </th>
          <th colspan="4" style="background-color: #f0f0fd">
            <div class="flex justify-center items-center gap-3">
              <p>구성성분정보</p>
            </div>
          </th>
          <th colspan="8">주요관리항목</th>
        </tr>
        <tr>
          <th style="background-color: #f0f0fd">구성물질</th>
          <th style="background-color: #f0f0fd">CAS No.</th>
          <th style="background-color: #f0f0fd">함량(%)</th>
          <th style="background-color: #f0f0fd">성상</th>
          <th>특별관리물질</th>
          <th>관리대상물질</th>
          <th>작업환경측정</th>
          <th>특수건강검진</th>

          <th>유독물질</th>
          <th>제한물질</th>
          <th>금지물질</th>
          <th>사고대비물질</th>
        </tr>
        </thead>
        <tbody is="draggable" :list="tableList" tag="tbody" handle=".handle">
        <!-- rows -->
        <tr v-for="(rows, indexRows) in tableList" :key="indexRows">
          <td v-if="!isPrint">
            <div class="flex items-center justify-center">
              <feather-icon class="handle" icon="MenuIcon" style="width: 14px; height: 14px; cursor: pointer" />
              <vs-checkbox v-model="rows.is_checked" class="custom-checkbox"></vs-checkbox>
            </div>
          </td>

          <!--  =========== 구성성분정보 ============== -->
          <td><ml-input :isPrint="isPrint" v-model="rows.구성물질" placeholder="벤진" /></td>
          <td><ml-input :isPrint="isPrint" v-model="rows.CAS" placeholder="86290-81-5" /></td>
          <td>
            <div v-if="rows.함량.범위 === '없음'" class="flex justify-center items-center gap-2">
              <vs-button class="py-1 px-2" color="secondary" @click="() => { rows.함량.범위 = '고정값' }">고정값</vs-button>
              <vs-button class="py-1 px-2" color="secondary" type="border" @click="() => { rows.함량.범위 = '범위' }">범위</vs-button>
            </div>
            <div v-if="rows.함량.범위 === '고정값'">
              <div class="flex gap-1 items-center">
                <ml-input :isPrint="isPrint" v-model="rows.함량.min" placeholder="0" />
                <feather-icon icon="XIcon" style="width: 24px; height: 24px; cursor: pointer" @click="() => { rows.함량.범위 = '없음'; rows.함량.min = ''; rows.함량.max = '' }" />
              </div>
            </div>
            <div v-if="rows.함량.범위 === '범위'">
              <div class="flex gap-1 items-center">
                <ml-input :isPrint="isPrint" v-model="rows.함량.min" placeholder="0" />
                <span>~</span>
                <ml-input :isPrint="isPrint" v-model="rows.함량.max" placeholder="100" />
                <feather-icon icon="XIcon" style="width: 24px; height: 24px; cursor: pointer" @click="() => { rows.함량.범위 = '없음'; rows.함량.min = ''; rows.함량.max = '' }" />
              </div>
            </div>
          </td>
          <td><ml-input :isPrint="isPrint" v-model="rows.성상" placeholder="액체" /></td>
          <!--  =========== 구성성분정보END ============== -->

          <!-- 주요관리항목 / 특별관리물질 -->
          <td><vs-checkbox :readonly="isReadonly" v-model="rows.특별관리물질" class="custom-checkbox" /></td>
          <!-- 주요관리항목 / 관리대상물질 -->
          <td><vs-checkbox :readonly="isReadonly" v-model="rows.관리대상물질" class="custom-checkbox" /></td>
          <!-- 주요관리항목 / 작업환경측정 -->
          <td><vs-checkbox :readonly="isReadonly" v-model="rows.작업환경측정" class="custom-checkbox" /></td>
          <!-- 주요관리항목 / 특수건강검진 -->
          <td><vs-checkbox :readonly="isReadonly" v-model="rows.특수건강검진" class="custom-checkbox" /></td>

          <!-- 주요관리항목 / 유독물질 -->
          <td><vs-checkbox :readonly="isReadonly" v-model="rows.유독물질" class="custom-checkbox" /></td>
          <!-- 주요관리항목 / 제한물질 -->
          <td><vs-checkbox :readonly="isReadonly" v-model="rows.제한물질" class="custom-checkbox" /></td>
          <!-- 주요관리항목 / 금지물질 -->
          <td><vs-checkbox :readonly="isReadonly" v-model="rows.금지물질" class="custom-checkbox" /></td>
          <!-- 주요관리항목 / 사고대비물질 -->
          <td><vs-checkbox :readonly="isReadonly" v-model="rows.사고대비물질" class="custom-checkbox" /></td>

        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import NumberInput from "@/components/NumberInput.vue";

export default {
  components: {
    FileUploader,
    CustomOptionSelector,
    draggable,
    NumberInput,
  },
  props: {
    title: {
      type: String,
      default: () => "MSDS",
    },
    value: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  data() {
    return {
      tableList: this.value,
    };
  },
  computed: {
    tableAllCheck: {
      get() {
        if (this.tableList.length > 0) {
          return this.tableList.every((data) => data.is_checked);
        }
        return false;
      },
      set(value) {
        for (const data of this.tableList) {
          data.is_checked = value;
        }
      },
    },
    checkList() {
      return this.tableList.filter((data) => data.is_checked);
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.tableList = value;
        }
      },
    },
    tableList(value) {
      this.$emit("input", value);
    },
  },
  created() {
    if (this.tableList.length === 0) {
      this.handleAddRow();
    }
  },
  methods: {
    checkForm(value, indexRows, text) {
      if (value.target.checked) {
        this.$emit("update-list-check", indexRows - 1, text);
      } else {
        this.$emit("update-list-check", indexRows - 1, "");
      }
    },
    // 항목추가
    handleAddRow() {
      this.tableList.push({
        is_checked: this.tableAllCheck,

        구성물질: "",
        CAS: "",
        함량: {
          범위: "없음",
          min: "",
          max: "",
        },
        성상: "",

        특별관리물질: false,
        관리대상물질: false,
        작업환경측정: false,
        특수건강검진: false,
        유독물질: false,
        제한물질: false,
        금지물질: false,
        사고대비물질: false,
      });
      this.updateList();
    },
    // 선택삭제
    handleRemoveRow() {
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].is_checked) {
          this.tableList.remove(this.tableList[i]);
          i = -1;
        }
      }
      if (this.tableList.length === 0) {
        this.handleAddRow();
      }
      this.updateList();
    },
    addIngredients() {
      this.checkList.forEach((data) => {
        data.구성성분.push({
          구성물질: "",
          CAS: "",
          함량: "",
          성상: "",
        });
      });
      this.updateList();
    },
    popIngredients() {
      this.checkList.forEach((data) => {
        data.구성성분.pop();
        if (data.구성성분.length === 0) {
          data.구성성분.push({
            구성물질: "",
            CAS: "",
            함량: "",
            성상: "",
          });
        }
      });
      this.updateList();
    },
    // update
    updateList() {
      this.$emit("updateList", this.tableList);
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;

.custom-checkbox::v-deep {
  justify-content: center !important;
  .vs-checkbox {
    margin: 0 !important;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th {
    font-weight: 700;
    font-size: 14px;
    text-align: center;

    background-color: #f9f9f9;
    border: 1px solid #cdcdcd;

    padding: 7px 11px;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 7px;
  }

  .tditem {
    & > * {
      border-right: 1px solid #cdcdcd;
      border-bottom: 1px solid #cdcdcd;
      padding: 7px;
      &:last-child {
        border-right: 0;
      }
    }

    &:last-child > * {
      border-bottom: 0;
    }
  }
}
</style>
